import * as yup from 'yup'
import { DGSegregationRuleFormProfile } from './dg-segregation-rules-table-form.profile'

export const schema: yup.ObjectSchema<DGSegregationRuleFormProfile> = yup.object({
  distance: yup
    .number()
    .typeError('Distance must be a number')
    .required('Distance is required')
    .min(0, 'Distance must be 0 or greater'),
  isProhibited: yup.boolean().required(),
})
